import { createSelector, Selector } from 'reselect'
import { BRANCH_KEY } from '../branch'
import { IOrchestrationOwnState } from '../model'
import { IOrchestrationState } from './models'

const branch: Selector<IOrchestrationOwnState, IOrchestrationState> = (state) => state[BRANCH_KEY].orchestration

export const isWipingBuilding = createSelector(branch, (branch) => branch.isWipingBuilding)
